<template>
  <div class="container">
	<b-row>
		<b-col md="12" class="p-0">
			<div>
				<Slider v-bind:items="params['slider_items']" v-bind:settings="slider_settings" v-bind:page="'investors'"></Slider>
			</div>
		</b-col>
  	</b-row>
  </div>
</template>
<script>
import Slider from '@/components/Slider.vue'

export default {
	name: 'report',
	components: {
		Slider
	},
	props: ['params'],
	data() {
		return {
			slider_settings: {
				main_class: 'report',
				mouseDrag: false,
				shortDrag: false, // so it won't slide on mobile screen just by touching it
				transition: 600,
				wheelControl: false,
				initialSlide: 0,
				infiniteScroll: true,
				centerMode: false,
				itemsToSlide: 1,
				breakpoints: {
		            0: {
		              itemsToShow: 3,
		              // centerMode: false,
		              // pagination: 'indicator'
		            },
					767.98: {
					  itemsToShow: 6,
					},
		            991.98: {
					  itemsToShow: 7
		              // pagination: 'fraction'
		            },
					1200: {
					  itemsToShow: 7
					}
	          	}
	        }
		}
	}
	/*created() {
		console.log(this.params);
	}*/
}
</script>
<style>

</style>